import { EditorView } from 'prosemirror-view';

import { EmojiServiceInternal } from './emoji-service-internal';

export class EmojiServicePublic {
  constructor(private editorView: EditorView, private emojiServiceInternal: EmojiServiceInternal) {}

  public emojiWithSearchOpen(origin: HTMLElement) {
    const position = origin.getBoundingClientRect();
    this.emojiServiceInternal.currentOrigin = origin;

    this.emojiServiceInternal.openPicker(position, { withSearch: true });
    const { from, to } = this.editorView.state.selection;

    const onSelect = this.emojiServiceInternal.getEmojiSelectCallback(from, to);
    this.emojiServiceInternal.setSelectCallback(onSelect);
  }
}
